<div *ngIf="activeQuestion" [formGroup]="activeQuestion" class="hidden-choice-settings">
  <div class="hidden-choice-settings__title">
    <span class="fs__lg fw__500">Hidden variables</span>
    <span class="fs__md caption">
      The left value serves as the choice Id and it is used as the hidden variable value. The right text is the label assigned to that value.
    </span>
  </div>
  <div formArrayName="options" class="hidden-choice-settings__table">
    <div class="hidden-choice-settings__header-row fs__md fw__500">
      <span>Value</span>
      <span>Text</span>
    </div>
    <div
      *ngFor="let optionCtrl of (activeQuestion.get('options') | toFormArray).controls; let i = index"
      [formGroupName]="i"
      class="hidden-choice-settings__edit-row"
    >
      <mat-form-field appearance="outline"> <input matInput formControlName="value" autocomplete="off" [value]="optionCtrl.value.value" /> </mat-form-field>
      <mat-form-field appearance="outline"> <input matInput [disabled]="true" [value]="optionCtrl.value.text | toPlainText" /> </mat-form-field>
    </div>
  </div>
</div>

@if (hiddenQuestionsToCopyOptionsFrom.length > 0) {
  <div class="hidden-choice-settings__question-selector">
    <div class="hidden-choice-settings__question-select">
      <span class="fs__sm fw__500">Copy the options from:</span>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="questionToCopyFromCtrl">
          <mat-option *ngFor="let question of hiddenQuestionsToCopyOptionsFrom" [value]="question.id">{{ question.code }} - {{ question.title }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
}
